
(function roleAssociateFunctionsControllerDefinition() {
    'use strict';

    angular.module('Role')
        .controller('RoleAssociateFunctionsController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'adminRoleService', 'functionService','$filter',
            function roleAssociateFunctionsController($scope, config, $state, $translate, $stateParams, errors, adminRoleService, functionService, $filter) {
                $scope.models = {
                    selected: null,
                    associated: {
                        "title": null,
                        "list": []
                    },
                    availables: {
                        "title": null,
                        "list": []
                    }
                };

                $scope.cancel = function () {
                    $state.go('role-find-preselect', { name: adminRoleService.getFilter().Name });
                };

                $translate(['RoleAssociateFunctionsTitle', 'FunctionAssociatedList', 'FunctionAvailableList']).then(function (translated) {
                    $scope.title = translated.RoleAssociateFunctionsTitle;
                    $scope.models.associated.title = translated.FunctionAssociatedList;
                    $scope.models.availables.title = translated.FunctionAvailableList;
                });

                $scope.moveItemFromAssociated = function (item, index) {
                    $scope.models.associated.list.splice(index, 1);
                    $scope.models.availables.list.push(item);
                }

                $scope.moveItemFromAvailables = function (item, index) {
                    $scope.models.availables.list.splice(index, 1);
                    $scope.models.associated.list.push(item);
                }

                adminRoleService.getById($stateParams.id).then(function (result) {
                    $scope.role = result;
                    result.functions = $filter('orderBy')(result.functions, 'translatedName');
                    $scope.models.associated.list = result.functions;
                }, function (error) {
                    errors.showError(error);
                    $scope.cancel();
                }).then(function () {
                    functionService.getNotInRole($stateParams.id).then(function (result) {
                        result = $filter('orderBy')(result, 'translatedName');
                        $scope.models.availables.list = result;
                    });
                });
                
                $scope.save = function () {
                    return adminRoleService.modify($scope.role).then(function () {
                        $state.go('role-document-types', { id: $scope.role.id, name: $scope.role.name });
                    },
                        function (error) {
                            errors.showError(error);
                        });
                };
            }
        ]);
})();